/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'download': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M432 0h160c26.6 0 48 21.4 48 48v336h175.4c35.6 0 53.4 43 28.2 68.2L539.4 756.6c-15 15-39.6 15-54.6 0L180.2 452.2C155 427 172.8 384 208.4 384H384V48c0-26.6 21.4-48 48-48zm592 752v224c0 26.6-21.4 48-48 48H48c-26.6 0-48-21.4-48-48V752c0-26.6 21.4-48 48-48h293.4l98 98c40.2 40.2 105 40.2 145.2 0l98-98H976c26.6 0 48 21.4 48 48zM776 928c0-22-18-40-40-40s-40 18-40 40 18 40 40 40 40-18 40-40zm128 0c0-22-18-40-40-40s-40 18-40 40 18 40 40 40 40-18 40-40z"/>'
  }
})
